import { IMAGES } from "./imagesImports";

export const section2Images = [
    {
        src: IMAGES.FIN_SEC2_IMG1,
        alt: "locataion icon",
        text: 'Localization for multilingual financial reporting'
    },
    {
        src: IMAGES.FIN_SEC2_IMG2,
        alt: "locataion icon",
        text: 'Certified translation service for official filings'
    },
    {
        src: IMAGES.FIN_SEC2_IMG3,
        alt: "locataion icon",
        text: 'Translation of financial reports and audit documentation'
    },
    {
        src: IMAGES.FIN_SEC2_IMG4,
        alt: "locataion icon",
        text: 'Translation of financial statements and cash flow statements'
    },
    {
        src: IMAGES.FIN_SEC2_IMG5,
        alt: "locataion icon",
        text: 'Support for financial services translation in various language pairs'
    },
];

export const section3Images = [
    {
        src: IMAGES.FIN_ASSESSMENT_1,
        mobileSrc: IMAGES.FIN_ASSESSMENT_1_MOBILE,
        alt: "birth_assessment_1",
        heading: 'Upload the document',
        description: 'We securely receive your file for review.',
        backgroundColor: '#F46350'
    },
    {
        src: IMAGES.FIN_ASSESSMENT_2,
        mobileSrc: IMAGES.FIN_ASSESSMENT_2_MOBILE,
        alt: "birth_assessment_2",
        heading: 'Assessment',
        description: 'We evaluate document complexity, page count, and translator availability.',
        backgroundColor: '#7245ED'
    },
    {
        src: IMAGES.FIN_ASSESSMENT_3,
        mobileSrc: IMAGES.FIN_ASSESSMENT_3_MOBILE,
        alt: "birth_assessment_3",
        heading: 'Translation by experts',
        description: 'A professional financial translator begins the project.',
        backgroundColor: '#12ABBF'
    },
    {
        src: IMAGES.FIN_ASSESSMENT_4,
        mobileSrc: IMAGES.FIN_ASSESSMENT_4_MOBILE,
        alt: "birth_assessment_4",
        heading: 'Proofreading and certificatio',
        description: 'We issue a certificate of translation accuracy, certified by a professional financial translator.',
        backgroundColor: '#F46350'
    },
    {
        src: IMAGES.FIN_ASSESSMENT_5,
        mobileSrc: IMAGES.FIN_ASSESSMENT_5_MOBILE,
        alt: "birth_assessment_5",
        heading: 'Delivery',
        description: 'You get your translation on time. We support standard and urgent turnaround schedules.',
        backgroundColor: '#7245ED'
    },
];

export const section5Images = [
    {
        src: IMAGES.FIN_SEC5_IMG1,
        heading: 'Accurate Financial Translation for Global Use',
        text: 'Our financial translation services support global transactions, international reporting, and investor relations. We serve finance professionals, corporations, and institutions that require accurate translations for multilingual financial communications. <br/> <br/> Every financial statement translation meets international standards. We help ensure your financial health is represented clearly across borders'
    },
    {
        src: IMAGES.FIN_SEC5_IMG2,
        heading: 'Financial Translations Require Accuracy and Speed',
        text: 'Financial deadlines are non-negotiable. We work within short translation turnaround times while maintaining professional standards. Whether translating financial statements or preparing documents for an audit, our team ensures every translation is accurate. <br/> <br/> We provide quick, efficient service for businesses that need to translate financial materials on time.'
    }
]

export const section6Images = [
    {
        src: IMAGES.FIN_SEC6_IMG1,
        alt: 'sec-6-image-1',
        text: 'Finance translation for mergers, acquisitions, and investor relations'
    },
    {
        src: IMAGES.FIN_SEC6_IMG2,
        alt: 'sec-6-image-2',
        text: 'Financial terminology precision'
    },
    {
        src: IMAGES.FIN_SEC6_IMG3,
        alt: 'sec-6-image-3',
        text: 'Localization of financial content for global clients'
    },
    {
        src: IMAGES.FIN_SEC6_IMG4,
        alt: '4',
        text: 'Translation of annual reports and financial disclosures'
    }
]